import { render, staticRenderFns } from "./promesa.vue?vue&type=template&id=c02b36ac&scoped=true"
import script from "./promesa.vue?vue&type=script&lang=js"
export * from "./promesa.vue?vue&type=script&lang=js"
import style0 from "./promesa.vue?vue&type=style&index=0&id=c02b36ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02b36ac",
  null
  
)

export default component.exports